<template>
    <v-layout wrap>
        <v-flex xs12 v-if="!offices || offices.length === 0">
            <p class="text-xs-center">No se han encontrado sucursales</p>
        </v-flex>
        <v-flex v-else xs12 md4 v-for="(office, index) in offices" :key="index" class="pa-1 mx-auto">
            <v-sheet class="kim-card pa-2">
                <h1 class="title font-weight pb-1">
                    <v-icon :color="office.icon.color">{{ office.icon.name }}</v-icon>
                    {{ office.name }}
                </h1>
                <v-divider></v-divider>

                <v-layout wrap class="mt-2">
                    <v-flex xs12 v-for="(detail, i) in office.details" :key="index+'-'+i">
                        <template v-if="detail.value !== '-'">
                            <v-avatar size="24">
                                <v-icon size="16">{{ detail.icon }}</v-icon>
                            </v-avatar>
                            <span style="max-width: 100px" class="text-truncate" v-html="detail.value"/>
                        </template>
                    </v-flex>
                </v-layout>
            </v-sheet>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    props: ['provider'],
    computed: {
        offices() {
            const vm = this
            if (!vm.provider || (!vm.provider.institution && !vm.provider.user)) return []
            const provider = vm.provider.institution || vm.provider.user
            if (!provider.branch_offices) return []
            return provider.branch_offices.map(office => {
                return {
                    name: office.name,
                    details: [
                        {
                            icon: 'fas fa-phone',
                            value: office.phone1 ? `<a href='tel:${office.phone1}'>${office.phone1}</a>` : '-'
                        },
                        {
                            icon: 'fas fa-phone',
                            value: office.phone2 ? `<a href='tel:${office.phone2}'>${office.phone2}</a>` : '-'
                        },
                        {
                            icon: 'fas fa-map-marker-alt',
                            value: (office.address || '-')
                        },
                    ],
                    icon: {
                        name: 'fas fa-building',
                        color: office.main ? 'primary' : 'accent'
                    },
                }
            })
        }
    },
}
</script>